module.exports = __webpack_public_path__ + "static/img/b707e9a39d20342048a6de43f3adf756.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/codeImg.jpg
// module id = 0flx
// module chunks = 1